import { FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Text, Tooltip } from "@mantine/core";

export const IconInfo: FC<{
  tooltip: string;
  icon: any;
  label?: string;
  color?: string;
}> = ({ tooltip, icon, label = "", color = "gray.7" }) => (
  <Text fz="xs" c={color}>
    <Tooltip label={tooltip} withArrow withinPortal>
      <Text inherit span mr="8px" display="inline-block">
        <FontAwesomeIcon icon={icon} />
      </Text>
    </Tooltip>

    <Text inherit span>
      {label}
    </Text>
  </Text>
);
